export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-heading text-xl text-primary-500 font-bold tracking-wide">
              51黑料网
            </span>
            <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
              聚合每日最新黑料与八卦爆料，覆盖今日黑料最新、黑料每日更新及51黑料今日热点，快速获取新鲜黑料内容的娱乐资讯平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热度榜单</a>
              <a href="#topics" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门话题</a>
              <a href="#cards" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">最新爆料</a>
              <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-200 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              诚邀优质内容平台与媒体伙伴加入合作，共同打造更丰富的娱乐资讯生态。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-200 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2">
              <a href="#contact" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-mail-send-line mr-1.5"></i>爆料投稿
              </a>
              <a href="#contact" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-briefcase-line mr-1.5"></i>商务合作
              </a>
              <a href="#contact" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-shield-user-line mr-1.5"></i>侵权投诉
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 51黑料网 · 51黑料网今日黑料首页 · 黑料每日更新 · 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-600">今日黑料最新</span>
            <span className="text-xs text-foreground-600">51黑料今日</span>
            <span className="text-xs text-foreground-600">黑料新鲜事</span>
          </div>
        </div>
      </div>
    </footer>
  );
}